/// <reference path="../../../../../typings.d.ts" />

import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment';
import 'file-saver';
import { StorageUtil } from '../../../../utils/storage.util';
import { ActDialogStateService } from './act.dialog.contracts.state.service';
import { ContractsHttpUtil } from '../contracts.util';
import { ReportHttpService } from '../../../../services/report/report.http.service';
import { ContractModelService } from '../contracts.model.service';
import { AuthUtil } from '../../../../utils/auth.utils';
import { CALENDAR_LOCALE_RU } from '../../../../consts/locale';
import {DashboardHttpUtil} from '../../dashboard.util';
import {DevelopUtil} from '../../../../utils/develop.utils';

@Component({
  moduleId: module.id,
  selector: 'bft-act-dialog',
  templateUrl: 'act.dialog.contracts.component.html',
  styleUrls: ['act.dialog.contracts.component.css'],
  providers: []
})

export class ActDialogContractsComponent implements OnInit {

  @Input() initDate: string;

  model = {};
  displayDialog: boolean = false;
  loading: boolean = false;
  errorMessage = '';
  successMessage = '';

  readonly TAB_SINGLE = 'single';
  readonly TAB_PERIOD = 'period';
  activeTab = this.TAB_SINGLE;

  contractId;
  singleStartDate: any = new Date();
  singleEndDate: any = new Date();
  startDate: any = new Date();
  endDate: any = new Date();

  fileTypeList = [{label: 'PDF', value: 'PDF'}, {label: 'DOCX', value: 'DOCX'}];
  formatType = this.fileTypeList[0].value;

  fileName = 'report';

  localeRu = CALENDAR_LOCALE_RU;

  constructor(
    private actDialogStateService: ActDialogStateService,
    private reportHttpService: ReportHttpService,
    private contractModelService: ContractModelService,
    private authUtil: AuthUtil) {

    this.actDialogStateService.handleDialogStatus().subscribe(data => {
      this.displayDialog = data.display;
    });

  }

  ngOnInit() {
    if (this.initDate) {
      // this.singleDate = new Date(this.initDate);
      this.singleStartDate = new Date(this.initDate);
    }
    // TODO: func get document id
    this.model = this.contractModelService.getData();
    this.contractId = this.model['id'];
  }

  close($event) {
    $event.preventDefault();
    this.errorMessage = '';
    this.displayDialog = false;
  }

  download($event) {
    $event.preventDefault();
    this.loading = true;
    this.errorMessage = '';

    let startDate = this.singleStartDate;
    let endDate   = this.singleEndDate;

    if (this.activeTab === this.TAB_PERIOD) {
      startDate = this.startDate;
      endDate = this.endDate;
    }

    startDate = moment(startDate).format('YYYY-MM-DD');
    endDate = moment(endDate).format('YYYY-MM-DD');

    let data = {
      securityToken: StorageUtil.getToken(),
      formatType: this.formatType,
      startDate: startDate,
      endDate: endDate,
      contractId: this.contractId,
    };

    let requestParams = ContractsHttpUtil.prepareParamsDownload(data);
    window.open(ReportHttpService.REPORT_URL + '?' + requestParams.toString(), '_blank');
    this.loading = false;
    /*this.reportHttpService.getReport(requestParams)
      .map(res => {
        if (res.headers.get('content-disposition')) {
          this.fileName = res.headers.get('content-disposition').split('"')[1];
          return res.blob();
        }
      })
      .subscribe(
        blobContent => {
          this.loading = false;
          if(blobContent) {
            saveAs(blobContent, this.fileName);
          } else {
            this.errorMessage = 'Произошла ошибка.';
          }
        },
        error => {
          this.errorMessage = 'Произошла ошибка.';
          this.loading = false;
        },
        () => {
          this.loading = false;
        });*/
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/contracts/act-dialog/act.dialog.contracts.component.ts